import React, { useState, useEffect } from "react";
import DashboardHeaderStats from "../components/dashbord-new/dashboardHeaderStats";
import { annualViewTabs as AnnualViewTabsStyle } from "../css/styles/componentStyles";
import BudgetStatsCards from "../components/dashbord-new/budgetStatsCard";
import DashboardBudgetChart from "../components/dashbord-new/dashboardBudgetChart";
import DateFilterSelect from "../../../../../../CustomDatePicker/DateFilterSelectold";
import AccruedDropdown from "../components/AccruedDropdown";
// import DateFilterSelect from "../../../../Common/DateFilterSelectold"
// import DateFilterSelect from "../DateFilter";
import moment from "moment";
import Loader from '../../../../../../presentationals/Loader/Loader.component'
// import Loader from "../../../../Common/Loader.component"
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../../../../reducers/CommonFilters.reducer';
// import { FILTER_ACTION } from "../../../../reducers/CommonFilters.reducer";
import { getExpenseOverviewByDateRangeFilters,getExpenseTableByDateRangeFilters,getExpenseDASHboardsummaryByDateRangeFilters, getExpenseExpectedIncomeByDateRangeFilters } from "../utils/ActionCreator";
import useMockLoading from "../hooks/useMockLoading";
import { HeaderStatsSkeleton, BudgetStatsCardsSkeleton, BudgetChartSkeleton } from "../components/skeletons/DashboardSkeleton";

function DashboardView() {
  const dispatch = useDispatch();
  const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
  const [dateFilterPopup, setDateFilterPopup] = useState({ from:fromDate, to: toDate })
  const [accured, setAccured] = useState("")
  const [loader, setLoader] = useState(false)
  const [apiData, setApiData] = useState({ api1: {},api2:[],api3:{},api4:[] })

  const mockLoading = useMockLoading([dateFilterPopup.from, dateFilterPopup.to, accured], 600);

  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }));
    const formatted = moment(val).format("YYYY-MM-DD");

    setDateFilterPopup((prev) => {
      if (prev[type] === formatted) return prev;

      return {
        ...prev,
        [type]: formatted
      };
    });
    if (type === "from") {
      if (dateFilterPopup.from !== formatted) {
        // dispatch({ type: FILTER_ACTION, payload: { "fromDate": formatted } });
      }
    } else {
      if (dateFilterPopup.to !== formatted) {
        // dispatch({ type: FILTER_ACTION, payload: { "toDate": formatted } });
      }
    }
  }

  useEffect(() => {
    const obj = { from: dateFilterPopup.from, to: dateFilterPopup.to, accured: accured }
    MainApi(obj);
  }, [dateFilterPopup.from, dateFilterPopup.to, accured]);


  const MainApi = (data) => {
    setLoader(true)
    getExpenseOverviewByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api1: callback ?? {}
      }))
    }, (error) => {
      console.error("getExpenseOverviewByDateRangeFilters error:", error);
    })
    getExpenseTableByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api2: callback ?? []
      }))
    }, (error) => {
      console.error("getExpenseTableByDateRangeFilters error:", error);
    })
    getExpenseDASHboardsummaryByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api3: callback ?? []
      }))
    }, (error) => {
      console.error("getExpenseDASHboardsummaryByDateRangeFilters error:", error);
    })
    getExpenseExpectedIncomeByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api4: callback ?? []
      }))
    }, (error) => {
      console.error("getExpenseExpectedIncomeByDateRangeFilters error:", error);
    })
    setLoader(false)
  }

  return (
    <>
      {loader ? <Loader /> : ""}
      <div style={AnnualViewTabsStyle.container}>
        <div style={{ background: "#fff",
          padding: '16px 24px', borderRadius: '12px', margin: "0 0 24px 0", 
          boxShadow: "none",
          border: "1px solid rgba(226, 232, 240, 0.8)",
          }}>
          <div className="row">
            <div className=" col-xs-12" style={{ display: 'flex', flexWrap: 'wrap', gap: "15px 24px", alignItems: 'center' }}>
              <DateFilterSelect
                value={[new Date(dateFilterPopup.from), new Date(dateFilterPopup.to)]}
                onChange={(range) => {
                  handleDateFilterPopup("from", range[0]);
                  handleDateFilterPopup("to", range[1]);
                }}
                isFilterCleared={false}
                customStyle={{
                  border: "1px solid #d1d5db",
                  padding: "8px 14px",
                  height: "38px",
                  alignItems: "center",
                  boxSizing: "border-box",
                  backgroundColor: "#ffffff",
                  fontSize: "14px",
                  color: "#374151"
                }}
              />
              <AccruedDropdown value={accured} onChange={setAccured} />
            </div>


          </div>
        </div>
        <div style={AnnualViewTabsStyle.tabContainer}>
          {mockLoading ? (
            <>
              <HeaderStatsSkeleton />
              <div style={{ height: "20px" }} />
              <BudgetStatsCardsSkeleton />
            </>
          ) : (
            <>
              <DashboardHeaderStats apiData={apiData} />
              <BudgetStatsCards apiData={apiData}/>
            </>
          )}
        </div>
      </div>
      {mockLoading ? (
        <div style={{ padding: "0 90px" }}>
          <BudgetChartSkeleton />
        </div>
      ) : (
        <DashboardBudgetChart apiData={apiData} />
      )}
    </>
  );
}

export default DashboardView;
